/* eslint-disable
    no-param-reassign,
    @typescript-eslint/naming-convention,
    @typescript-eslint/no-unused-vars */
import { DreamBlock } from '@typedream/core';
import { getBlockAbove, getNode, setNodes } from '@udecode/plate-core';
import { Path } from 'slate';
import { DreamWithOverride } from '../../plate';
import { deleteBackwardList } from './deleteBackwardList';
import { deleteForwardList } from './deleteForwardList';
import { deleteFragmentList } from './deleteFragmentList';
import { insertBreakList } from './insertBreakList';
import { insertFragmentList } from './insertFragmentList';
import { normalizeList } from './normalizers';
import { getListTypes } from './queries';
import { ListPlugin } from './types';

export const withList: DreamWithOverride<ListPlugin> = (editor, plugin) => {
  const {
    insertBreak, deleteBackward, deleteForward, deleteFragment,
  } = editor;
  const { options: { validLiChildrenTypes } } = plugin;

  editor.insertBreak = () => {
    if (insertBreakList(editor)) return;

    insertBreak();
  };

  editor.deleteBackward = (unit) => {
    if (deleteBackwardList(editor, unit)) {
      const blockAbove = getBlockAbove(editor);
      if (!blockAbove) return;

      const [, path] = blockAbove;
      const previousNode = getNode<DreamBlock>(editor, Path.previous(path));
      const nextNode = getNode(editor, Path.next(path));
      if (!previousNode || !nextNode) return;

      if (
        getListTypes(editor).includes(previousNode.type)
        && previousNode.type === nextNode.type
      ) {
        // copy properties from first list to second list
        const { id: _, children: __, ...rest } = previousNode;
        setNodes(editor, rest, {
          at: Path.next(path),
        });
      }

      return;
    }

    deleteBackward(unit);
  };

  editor.deleteForward = (unit) => {
    if (deleteForwardList(editor)) return;

    deleteForward(unit);
  };

  editor.deleteFragment = () => {
    if (deleteFragmentList(editor)) return;

    deleteFragment();
  };

  editor.insertFragment = insertFragmentList(editor);

  editor.normalizeNode = normalizeList(editor, { validLiChildrenTypes });

  return editor;
};
